const notestype = {
	name: 'Note Type | Note Types',
	fields: {
		name: 'Name',
		color_header: 'Color',
	},
}

export default notestype
